import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router } from './router'
import { getLocale } from './paraglide/runtime'
import './index.css'

// Apply locale + direction before the first paint so RTL doesn't flash (#43/#44).
const locale = getLocale()
document.documentElement.lang = locale
document.documentElement.dir = locale === 'he' ? 'rtl' : 'ltr'

// Register the service worker up front so push subscription state can resolve
// (navigator.serviceWorker.ready otherwise never settles) and the app is
// installable as a PWA (required for iOS web push).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) =>
    console.error('Service worker registration failed:', err),
  )
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
